import React, { useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { handleMonth, translate } from "../../utils/Common";
import { IoIosArrowDown } from "react-icons/io";
import styles from "./YearMonthSelect.module.css";

const YearMonthSelector = ({ onSelect, objSelect, showMonths = true }) => {
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [showYears, setShowYears] = useState(false);
    const [hoveredYear, setHoveredYear] = useState(null);
    const [hoveredMonth, setHoveredMonth] = useState(null);

    // Generar los años desde 2011 hasta el año actual
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2011 + 1 }, (_, index) => currentYear - index);
    const months = Array.from({ length: 12 }, (_, i) => handleMonth(i + 1));
  
    const handleYearClick = (year) => {
      setSelectedYear(year); // Selecciona el año
      setSelectedMonth(null); // Limpia el mes seleccionado
      setHoveredYear(year); // Muestra los meses al hacer hover
      if (onSelect) {
        onSelect({ year, month: null }); // Devuelve el año seleccionado y mes vacío
      }
      setShowYears(false); // Oculta la lista de años
    };
  
    const handleMonthClick = (month) => {
      setSelectedMonth(month); // Selecciona el mes
      const yearToUse = hoveredYear || selectedYear; // Usa el año en hover o el seleccionado
      if (onSelect && yearToUse) {
        onSelect({ year: yearToUse, month: months.indexOf(month) + 1 }); // Devuelve el año y mes seleccionados
      }
      setShowYears(false); // Oculta la lista de años
    };
  
    return (
      <div className={styles.wrapper}>
        <div className={styles.triggerGroup}>
          <span className={styles.iconPrepend} aria-hidden>
            <FaCalendarAlt size={14} />
          </span>
          <div
            className={styles.trigger}
            onClick={() => setShowYears(!showYears)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowYears(!showYears)}
            aria-haspopup="listbox"
            aria-label={translate("global.selectYear") || "Seleccionar año"}
          >
            <span className={styles.triggerValue}>
              {objSelect?.year && objSelect?.month
                ? `${showMonths ? handleMonth(objSelect?.month, "L") : ""} ${objSelect?.year} `
                : objSelect?.year
                ? `${objSelect?.year}`
                : <span className={styles.placeholder}>Fecha</span>}
            </span>
            <IoIosArrowDown size={14} aria-hidden />
          </div>
        </div>

        {showYears && (
          <div
            className={`${styles.dropdown} ${showMonths ? styles.dropdownLeft : ""}`}
            onMouseLeave={() => {
              setShowYears(false);
              setHoveredYear(null);
              setHoveredMonth(null);
            }}
            role="listbox"
          >
            {showMonths && hoveredYear && (
              <div className={styles.monthsPanel}>
                {months.map((month, i) => (
                  <div
                    key={i}
                    className={`${styles.option} ${selectedMonth === month ? styles.optionSelected : ""} ${hoveredMonth === i + 1 ? styles.optionSelected : ""}`}
                    onClick={() => handleMonthClick(month)}
                    onMouseEnter={() => setHoveredMonth(i + 1)}
                    onMouseLeave={() => setHoveredMonth(null)}
                    role="option"
                    aria-selected={selectedMonth === month}
                  >
                    {month}
                  </div>
                ))}
              </div>
            )}
            <div className={styles.yearsPanel}>
              {years.map((year) => (
                <div
                  key={year}
                  className={`${styles.option} ${hoveredYear === year ? styles.optionSelected : ""}`}
                  onClick={() => handleYearClick(year)}
                  onMouseEnter={() => setHoveredYear(year)}
                  role="option"
                  aria-selected={hoveredYear === year}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
};

export default YearMonthSelector;